<template>
  <div class="col-sm-12 nopads">
    <div class="col-sm-12 editor-form" @click.stop="">
      <h2 class="editor-header">{{ observationGroupUpdate.id > 0 ? $t('observations.edit_group') : $t('observations.add_group')}}</h2>
      <div class="col-sm-12 form-data">
        <span class="span-title">{{ $t('observations.name') }}</span>
          <input
              id="name"
              v-model="observationGroupUpdate.name"
              type="text"
              class="form-control form-control-sm"
          />
          <div class="col-sm-12 d-flex justify-content-end my-2">
          <button
            class="btn btn-secondary form-button"
            @click.stop="$emit('close')"
          >
              {{ $t('common.cancel') }}
          </button>
          <button class="btn btn-success form-button" :disabled="loading" @click.stop="submit">
              {{ $t('common.save') }}
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {observationHelper} from '../../mixins/ObservationMixin'
import {restApi} from '../../mixins/RestApiMixin'
import {inject} from "vue";

export default {
    name: 'ObservationGroupEditor',
    mixins: [observationHelper, restApi],
    props: {
        observationGroup: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            observationGroupUpdate: this.jsonToItem(this.observationGroup)
        }
    },

    methods: {
        setDefaultValues: function (group) {
            if (group.name === '') {
                this.showAlert(this.$t('inspectable_editor.invalid_name'))
                return undefined
            }
            return group
        },

        submit: function () {
            let json = this.setDefaultValues(this.observationGroupUpdate)
            if (json !== undefined) {
                this.loading = true
                if (this.observationGroupUpdate.id < 1) {
                    this.restAdd(this.observationGroupUrl, json, this.success, this.fail)
                } else {
                    this.restUpdate(this.observationGroupUrl, json, this.success, this.fail)
                }
            }
        },

        success: function () {
            this.$emit('closeAndUpdate')
            this.loading = false
        },

        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        }

    }
}
</script>
